<template>
  <b-overlay :show="loading">
    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="12" lg="8">

          <b-alert v-if="error" show variant="danger" class="mt-2">
            {{errorMsg}}
            <!-- TBD error component. -->
          </b-alert>

          <!-- VIDEO DIV ========================================= -->
          <div v-if="showDivVideo">
            <b-row>
              <b-col cols="12" lg="8" offset-lg="1">
                <div class="sva-header">
                  {{msg}}
                </div>

                <div class="div-section-body">
                  <!-- https://getbootstrap.com/docs/4.4/utilities/flex/ -->
                  <div class="d-flex justify-content-center align-items-center pt-2 pb-2 pr-1">
                    <div>
                      <b-img fluid :src="svaObj.companyPhoto" />
                    </div>
                    <div class="pl-2">
                      {{blurb + ' ' + svaObj.companyName}}
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>

          <div v-if="videoId && showDivVideo" class="mt-2">
            <vue-plyr ref="svaplyr">
              <div class="yt-container">
                <!-- https://developers.google.com/youtube/iframe_api_reference -->
                <iframe
                  :src="getVideoUrl()"
                  allowfullscreen allowtransparency>
                </iframe>
              </div>
            </vue-plyr>
          </div>

          <!-- POST VIDEO DIV ========================================= -->
          <div v-if="showDivPostVideo">
            <b-row>
              <b-col>
                <div class="divOfferTitle">{{ svaObj.headline }}&nbsp;</div>
                <!-- <div class="divOfferBody">{{ svaObj.blurb | nl2br }}</div> -->
                <div class="divOfferBody" :inner-html.prop="svaObj.blurb | nl2br"></div>

                <div class="divQuestions">
                  <div class="divTitleBtns">{{ svaObj.headlineButtons }}&nbsp;</div>
                  <div class="divSubtitleBtns">(After your selection, you will be directed to CE exam)</div>
                  <div class="divOfferBtns">
                    <button @click.prevent="btnYes" class="btnYes btnFlat btnFlatGreen">{{ svaObj.buttonTextYes }}</button>
                    <button @click.prevent="btnNo" class="btnNo btnFlat btnFlatRed">{{ svaObj.buttonTextNo }}</button>
                  </div>
                </div>

                <div class="divReplay">
                  <button @click.prevent="replayVideo" class="btnFlat btnFlatGray">Replay Video</button>
                </div>
              </b-col>
            </b-row>
          </div>

        </b-col>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */
'use strict'

// Note use of v-show instead of v-if in the template.
// This keeps the video in the DOM in case of replay.
// https://vuejs.org/v2/guide/conditional.html

// vue-youtube
// https://www.npmjs.com/package/vue-youtube
// https://github.com/anteriovieira/vue-youtube
// youtube iframe api
// https://developers.google.com/youtube/iframe_api_reference#Events

import service from "@/service/service"
import youtubeMixin from "@/plugins/youtubeMixin"
import utils from "@/utils/utils"

export default {
  name: "SVA",
  data() {
    return {
      debug: false,
      loading: true,
      error: false,
      errorMsg: 'System error.  Contact technical support.',
      showDivVideo: false,
      showDivPostVideo: false,
      msg:
        "Press the play button to watch this video and proceed to your CE exam. Our video sponsors help keep Viva Learning FREE.",
      blurb: "This video is sponsored by ",
      classHash: null,
      studentHash: this.$root.getToken(),
      player: null,
      playerCounter: 0,
      playerTimer: null,
      videoId: null,
      svaObj: null
    }
  },
  props: {
    // route set to use props mapped to url parameters
    c: {
      type: String,
      required: true,
      default: null
    }
  },
  mixins: [youtubeMixin],
  computed: {
  },
  methods: {
    getVideoUrl() {
      let url = (this.videoId)
        ? utils.getYoutubeUrl(this.videoId, true)
        : null
      // console.log(`Video Url: ${url}`)
      return url
      // return 'https://www.youtube.com/embed/zpOULjyy-n8?rel=0'  // reo
      // return 'https://www.youtube.com/embed/pTvxZgiuU3Y?rel=0'
      // return 'https://www.youtube.com/watch?v=pTvxZgiuU3Y&rel=0'  // viva
    },
    clearPlayerTimer() {
      // if defined clear timer to get the vue plyr.
      if (this.playerTimer) window.clearInterval(this.playerTimer)
      this.playerTimer = null
    },
    playerEvents () { // load player events
      if (this.debug) {
        console.log(`playerEvents this.$refs`)
        console.log(this.$refs)
        console.log(`playerEvents this.$refs.svaplyr`)
        console.log(this.$refs.svaplyr)
      }

      if (!this.$refs.svaplyr) {
        this.playerCounter++
        if (this.playerCounter > 40) {
          this.clearPlayerTimer()
          this.bail('Timed out loading video.')   // TBD
        }
        if (this.debug) console.log(`${this.playerCounter}) NO PLAYER`)
        if (!this.playerTimer) {
          // Takes about 3 seconds for svaplyr to appear in $refs.
          this.playerTimer = window.setInterval( (function () { this.playerEvents() }).bind(this), 300 )
        }
        return
      }
      else {
        if (this.debug) console.log(`${this.playerCounter}) PLAYER FOUND`)
        this.clearPlayerTimer()
      }

      this.player = this.$refs.svaplyr.player
      // 'statechange','ready','canplay','error','progress','playing','play','pause','ended'
      this.player.on('statechange', ((e) => {
        // e.detail.code
        // -1 – unstarted
        // 0 – ended   YT.PlayerState.ENDED
        // 1 – playing  YT.PlayerState.PLAYING
        // 2 – paused  YT.PlayerState.PAUSED
        // 3 – buffering  YT.PlayerState.BUFFERING
        // 5 – video cued  YT.PlayerState.CUED   (not issued)
        if (this.debug) console.log(`Youtube event code: ${e.detail.code}`)
        if (e.detail.code == YT.PlayerState.ENDED) {
          this.ended()
        }
      }).bind(this))
    },
    ended() {
        console.log(`video ended`)
        this.player = null
        this.playerCounter = 0
        this.showDivVideo = false
        this.showDivPostVideo = true
    },
    btnYes(e) {
      if (this.debug) console.log(`btnYes`)
      this.btnSave(2)
    },
    btnNo(e) {
      if (this.debug) console.log(`btnNo`)
      this.btnSave(3)
    },
    async btnSave(eventId) {
      this.loading = true
      service
        .saveSvaResponse(
          this.classHash,
          this.studentHash,
          this.svaObj.id,
          eventId
        )
        .then(
          (data => {
            this.$router.push({ path: `/exam/${this.classHash}` })
          }).bind(this)
        )
        // .finally( e => {} )
        .catch(e => {
          this.error = true
          this.errorMsg = 'System API error saving response.'
          console.log(e);
        })
    },
    replayVideo(e) {
      if (this.debug) console.log(`btnReplay`)
      this.showDivVideo = true
      this.showDivPostVideo = false
      this.playerEvents()
    },
    bail(msg) {
      this.error = true
      this.errorMsg = msg
      this.showDivVideo = false
      this.showDivPostVideo = false
    }
  },
  async created () {
    this.classHash = this.c || null
    service
      .getSva(this.classHash, this.studentHash)
      .then(
        ( res => {
          if (res.status && res.rowCount !== 0) {
            // if (this.debug) console.log(data)
            this.svaObj = res.data[0];
            this.videoId = this.svaObj.youtubeId
            if (this.debug) console.log(`videoid: ${this.svaObj.youtubeId}   ${this.videoId}`)
            this.showDivVideo = true
          }
          else { // no sva to show, proceed to survey
            this.$router.push({ path: `/survey/${this.classHash}` })
          }
        }).bind(this)
      )
      .finally(e => {
        this.loading = false
      })
      .catch(e => {
        this.error = true
        this.errorMsg = "Error accessing API."
        console.log(e)
      })
  },
  async mounted() {
    if (this.debug) console.log(`SVA MOUNTED ------`)
    if (this.debug) console.log(`classhHash: ${this.classHash}  c: ${this.c}`)

    // need to do in mounted to access html elements
    let res = await this.checkYoutube()  // mixin (needs dom mounted)
    // console.log(resp)
    if (!res.hasYoutube) {
      // user has youtube blocked - proceed to survey
      // this.$router.push({ path: `/survey/${this.classHash}` });
      if (this.debug) console.log('YOUTUBE BLOCKED')
      return
    }
    this.playerEvents()
    // this.player.play()
  },
  beforeDestroy() {
    if (this.debug) console.log(`SVA destroy`)
    this.loading = true
    this.showDivVideo = false
    this.showDivPostVideo = false
    this.svaObj = {status: false}
    this.videoId = null
    if (this.player) this.player.destroy()
    this.playerCounter = 0
    this.clearPlayerTimer()
  },
  destroyed() {
    if (this.debug) console.log(`destroyed sva`);
    // this.destroyYoutube();
  }
}
</script>

<style scoped>

/* partial success on responsive iframe on mobile */
/* https://coolestguidesontheplanet.com/videodrome/youtube/ */
/* https://www.avexdesigns.com/blog/responsive-youtube-embed */
/* https://blog.theodo.com/2018/01/responsive-iframes-css-trick/ */

.yt-container {
  position:relative;
  padding-bottom:56.25%;
  padding-top:30px;
  height:0;
  overflow:hidden;
}
.yt-container iframe, .yt-container object, .yt-container embed {
  position:absolute;
  top:0;
  left:0;
  width:100% !important;
  height:100% !important;
}

.sva-header {
  /* font-family: verdana, helvetica, arial, sans-serif; */
  font-size: 1rem;
  font-weight: bold;
  color: black;
  padding: 10px 0px 15px;
  text-align: left;
}

.headline {
  /* font-family: verdana, helvetica, arial, sans-serif; */
  font-size: 18px;
  font-weight: bold;
}

.divSponsorText {
  margin: 10px 0px 0px 10px;
  font-size: 14px;
}

button {
  display: inline-block;
  margin: 0 15px 0 0;
  padding: 5px 25px;
  font-size: 18px;
  font-family: verdana, helvetica, arial, san-serif;
  line-height: 1.8;
  vertical-align: bottom;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
}

.btnFlat {
  color: #fff;
  background-color: #6496c8;
  text-shadow: -1px 1px #417cb8;
  border: none;
}

.btnFlat:hover {
  background-color: #346392;
  text-shadow: -1px 1px #27496d;
}

.btnFlat:active {
  background-color: #27496d;
  text-shadow: -1px 1px #193047;
}

.btnFlatRed {
  color: #fff;
  background-color: #ec1f26;
  text-shadow: -1px 1px #f77;
  border: none;
}

.btnFlatRed:hover {
  background-color: #f77;
  text-shadow: -1px 1px #f55;
}

.btnFlatRed:active {
  background-color: #f33;
  text-shadow: -1px 1px #000;
}

.btnFlatGreen {
  color: #fff;
  background-color: #3bb474;
  text-shadow: -1px 1px #7f7;
  border: none;
}

.btnFlatGreen:hover {
  background-color: #7f7;
  text-shadow: -1px 1px #5f5;
}

.btnFlatGreen:active {
  background-color: #3f3;
  text-shadow: -1px 1px #000;
}

.btnFlatGray {
  color: #fff;
  background-color: #ccc;
  text-shadow: -1px 1px #777;
  border: none;
}

.btnFlatGray:hover {
  background-color: #777;
  text-shadow: -1px 1px #555;
}

.btnFlatGray:active {
  background-color: #333;
  text-shadow: -1px 1px #000;
}

.preVideo {
  margin: 10px 0;
  text-align: left;
  font-size: 14px;
}
.postVideo {
  margin: 10px 0;
  text-align: left;
  font-size: 14px;
}

.divOfferTitle {
  font-size: 24px;
  line-height: 120%;
  font-weight: normal;
  margin: 20px auto 0 10px;
}
.divOfferBody {
  font-size: 20px;
  font-weight: normal;
  line-height: 135%;
  margin: 20px auto 0 10px;
}

.divQuestions {
  background-color: white;
  margin-top: 20px;
  padding: 20px;
}

.divTitleBtns {
  font-size: 22px;
  line-height: 120%;
  margin: 0px;
}
.divSubtitleBtns {
  color: #888;
  font-size: 18px;
  margin-top: 20px;
  text-align: center;
}
.divOfferBtns {
  margin-top: 25px;
  text-align: center;
}
.divReplay {
  margin-top: 25px;
  text-align: center;
}
.lnkReplay {
  color: #777;
  font-size: 14px;
  margin-left: -22px;
}
</style>



// WEBPACK FOOTER //
// src/components/SVA.vue